// extracted by mini-css-extract-plugin
export default {"menuRoot":"Sidebar-FBT_menuRoot__r8lx3"};